import React from "react";

import Script from "dangerous-html/react";
import { Helmet } from "react-helmet";

import Navigation from "../../components/layout/Navigation";
import Footer from "../../components/layout/Footer";
import HeroSection from "../../components/home/HeroSection";
import AboutSection from "../../components/home/AboutSection";
import ProcessSection from "../../components/home/ProcessSection";
import StatsSection from "../../components/home/StatsSection";
import TestimonialsSection from "../../components/home/TestimonialsSection";
import ContactSection from "../../components/home/ContactSection";
import ServicesSection from "../../components/home/ServicesSection";
import ExpertiseSection from "../../components/home/ExpertiseSection";
import ProjectsSection from "../../components/home/ProjectsSection";

import "./HomePage.css";

const HomePage: React.FC = () => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Anuj Kumar Tiwari</title>
        <meta property="og:title" content="Anuj Kumar Tiwari" />
        <link rel="canonical" href="https://anuj-portfolio-oq0kfe.app/" />
      </Helmet>
      <Navigation />

      <section className="home-section">
        <HeroSection />
      </section>

      <section className="home-section home-section-alt">
        <ServicesSection />
      </section>
      <section className="home-section">
        <ExpertiseSection />
      </section>
      <section className="home-section home-section-alt">
        <ProjectsSection />
      </section>
      <section className="home-section home-section-alt">
        <AboutSection />
      </section>
      <section className="home-section">
        <ProcessSection />
      </section>
      <section className="home-section">
        <StatsSection />
      </section>
      <section className="home-section home-section-alt">
        <TestimonialsSection />
      </section>
      <section className="home-section">
        <ContactSection />
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
